import { useEffect, useState } from 'react';
import { EventSourcePolyfill } from 'event-source-polyfill';
import {SSEEventListener} from './SSEEventListener';
import { v4 as uuidv4 } from 'uuid';
import { useGlobalStore } from '../core/GlobalStore';

export function getBffNotificationUrl() {
  return `/notification-api`;
}

export const useSSE = (token:string,currentStoreId:string,enterpriseId:string,handler:Function) => {

  const { setSSEConnected } = useGlobalStore();
  const sseClient = SSEEventListener(setSSEConnected);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (token) {
      const toBearerAuth = (token: string) => `Bearer ${token}`;
      const queryParams = new URLSearchParams({
        enterpriseId,
        storeId: currentStoreId,
        uid: uuidv4(),
      });
      const url = `${getBffNotificationUrl()}/stream?${queryParams.toString()}`;
      let eventSource = new EventSourcePolyfill(url, {
        headers: { Authorization: toBearerAuth(token) },
      });
      sseClient.connect(eventSource, handler);
      setConnected(true);
      return () => {
        sseClient.close();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return connected;
}
